import CustomContent from "@arcgis/core/popup/content/CustomContent";
import { addToSelectionAction } from "../../templates/popupTemplate/actions";
import { addImagerytoView } from "../../widgets/custom/doc-overlay/DocOverlayVM";
import { injectPopupDetailsIntoContent } from "../../widgets/custom/popup-details/PopupDetailsVM";
import addSelectedFeatureToSelectionLayer from "../../utility-tools/addSelectedFeatureToSelection";
import removeSelectedFeatureFromSelectionLayer from "../../utility-tools/removeSelectedFeatureFromSelection";

const LoadWidgetOnMount = (view,layerIds,pageConfig) => {
  let node = document.createElement("div");
    view.popup.dockEnabled = true;
    view.popup.dockOptions.position="bottom-right";
    view.map.allLayers.forEach((layer) => {
      layer.when((layer) =>{
            if (layer.type === "feature") {
        let customContentWidget = new CustomContent({
          outFields: ["*"],
          creator: () => {
              injectPopupDetailsIntoContent(view, node,layerIds,pageConfig);
              return node;
          },
        });
        
          layer.popupTemplate.content.push(customContentWidget)
          layer.popupTemplate.set("actions", [addToSelectionAction]);
     
        
      }
    });
    });
        view.popup.on("trigger-action", (e) => {
      if (e.action.id === "add-selection") {
        addSelectedFeatureToSelectionLayer(view)
      }
      if (e.action.id === "remove-selection") {
        removeSelectedFeatureFromSelectionLayer(view)
        
      }
    });

};
export default LoadWidgetOnMount;
